import { Component, OnInit } from '@angular/core';
import { commonService } from '../../../service/common.service';
import { FollowerService } from '../../../service/follower.service';
import { HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../../globals';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-followerlist',
  templateUrl: './followerlist.component.html',
  styleUrls: ['./followerlist.component.css'],
  providers:[commonService,FollowerService,Globals]
})
export class FollowerlistComponent implements OnInit {
  tabactive:string;
  userData:any;
  msg="";
  myfollower:any=[];
  myfollowersearchinput:String="";
  modalReference:NgbModalRef;
  modalDataLoading:Boolean=false;
  myfollowersearchdata:any=[];
  constructor(private modalService: NgbModal,private commonService:commonService,private followerService:FollowerService,private global: Globals,private router: Router,private route: ActivatedRoute) {
  this.userData=this.commonService.user;

  }
  openModal(content) {
    this.modalReference =  this.modalService.open(content,{ size: 'lg',keyboard:false,backdrop:'static' });        
  }

  ngOnInit() {
    this.tabactive='myfollower';
    let obj={};
    obj['userId']=this.userData.id;
    obj['limit']=4;
    obj['rand']=true;
    this.myfollowercommon(obj);

  }
  tab(tab){
    this.tabactive=tab;
  }

  myfollowercommon(obj){
    let role=this.userData.userType;
    if(role==4){
      this.myStudentFollower(obj);
    }else if(role==3){
      this.myTeacherFollower(obj);
    }

  }

  myfollowercommonSearch(obj){
    let role=this.userData.userType;
    obj['userId']=this.userData.id;
    if(role==4){
      this.myStudentFollowerSearch(obj);
    }else if(role==3){
      this.myTeacherFollowerSearch(obj);
    }

  }

  myStudentFollower(obj){      
        this.followerService.myStudentFollower(obj).subscribe((data:any)=>{
          console.log("follower");
          console.log(data.result);
          Array.prototype.push.apply( this.myfollower,data.result);            
        },(error:HttpErrorResponse)=>{
          this.msg="internal server error!";
        })
  }

  myTeacherFollower(obj){      
    this.followerService.myTeacherFollower(obj).subscribe((data:any)=>{
      Array.prototype.push.apply( this.myfollower,data.result);            
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
  }

  getImagePath(path,anonymously){
    if(!path || anonymously==1){
      path='avatar.png';
    }
    let res=this.global.profileUrl+path;
    return res;
  }

  follow(userObj,index){
    let obj={};
    obj['f_userid']=this.userData.id;
    obj['t_userid']=userObj.id;
    this.followerService.follow(obj).subscribe((data:any)=>{

      this.myfollower.splice(index,1);
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";

    })
  }

  myfollowersearch(search,template){
    this.modalDataLoading=false;
    this.openModal(template);
    let obj={};
    obj['search']=search;
    this.myfollowercommonSearch(obj);
  }

  otherfollowersearch(search,template){
    this.modalDataLoading=false;
    this.openModal(template);
    let obj={};
    obj['emailsearch']=search;
    this.myfollowercommonSearch(obj);
  }

  myStudentFollowerSearch(obj){    
    //console.log("student search"); 
    //console.log(obj); 
    this.followerService.myStudentFollower(obj).subscribe((data:any)=>{ 
           console.log('student search result');
           console.log(data.result);
     this.myfollowersearchdata=data.result;   
      this.modalDataLoading=true;         
    },(error:HttpErrorResponse)=>{
     
      this.msg="internal server error!";
    })
}

myTeacherFollowerSearch(obj){      
  this.followerService.myTeacherFollower(obj).subscribe((data:any)=>{
    this.modalDataLoading=true;
    this.myfollowersearchdata=data.result;             
  },(error:HttpErrorResponse)=>{
    this.msg="internal server error!";
  })
}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/right-sidebar/followerlist/followerlist.component.ts